import api from '@/services/api';

export default {
  async getUserSettings(includePermissions) {
    try {
      let response = await api.get(`Accounts/UserSettings?includePermissions=${Boolean(includePermissions)}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  }
}
